// CSRFトークンを取得する関数
function getCookie(name) {
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

// APIのベースURL
const API_BASE_URL = process.env.API_ENDPOINT || 'http://localhost:8000'

// 共通のfetch設定
const fetchConfig = (method, data = null) => {
  const config = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': getCookie('csrftoken')
    },
    credentials: 'include'
  }
  
  if (data && method !== 'GET') {
    config.body = JSON.stringify(data)
  }
  
  return config
}

export default {
  // LP データ取得
  async getLPData() {
    try {
      const response = await fetch(`${API_BASE_URL}/wait4/lp-data/`, fetchConfig('GET'))
      
      // レスポンスのContent-Typeをチェック
      const contentType = response.headers.get('content-type')
      if (!contentType || !contentType.includes('application/json')) {
        console.error('Expected JSON but received:', contentType)
        console.error('Response status:', response.status)
        
        // HTMLレスポンスの場合、内容を確認
        if (contentType && contentType.includes('text/html')) {
          const text = await response.text()
          console.error('HTML response received:', text.substring(0, 200))
          throw new Error(`APIがHTMLを返しました。URLまたは認証に問題がある可能性があります。`)
        }
      }
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      return response.json()
    } catch (error) {
      console.error('getLPData error:', error)
      throw error
    }
  },
  
  // 申し込み送信
  async submitApplication(data) {
    const response = await fetch(`${API_BASE_URL}/wait4/apply/`, fetchConfig('POST', data))
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  },
  
  // アナリティクス送信
  async trackAnalytics(data) {
    const response = await fetch(`${API_BASE_URL}/wait4/analytics/`, fetchConfig('POST', data))
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  },
  
  // 求人検索
  async searchJobs(conditions) {
    const response = await fetch(`${API_BASE_URL}/wait4/search/`, fetchConfig('POST', { conditions }))
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  },
  
  // AI面接シミュレーター
  async startInterview(data) {
    const response = await fetch(`${API_BASE_URL}/wait4/interview/`, fetchConfig('POST', data))
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  },
  
  // 相談予約
  async bookConsultation(data) {
    const response = await fetch(`${API_BASE_URL}/wait4/consultation/`, fetchConfig('POST', data))
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  }
}


// WEBPACK FOOTER //
// ./src/api/wait4.js